// src/services/newsService.js
import axiosInstance from './api/axiosInstance'; // Ajuste o caminho se necessário

/**
 * Busca todas as notícias ativas para exibição na plataforma do cliente.
 * @returns {Promise<Array>} Uma lista de notícias ativas.
 */
const getActiveNews = async () => {
    // Chama a nova rota que criamos no backend
    const response = await axiosInstance.get('/news/active');
    return response.data;
};

export const newsService = {
    getActiveNews,
};